import { render, staticRenderFns } from "./group-xiaoyu.vue?vue&type=template&id=50ee9b0f&"
import script from "./group-xiaoyu.vue?vue&type=script&lang=ts&"
export * from "./group-xiaoyu.vue?vue&type=script&lang=ts&"
import style0 from "./group-xiaoyu.vue?vue&type=style&index=0&id=50ee9b0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports